import type { CreateQrBatchRequest, ListQrBatchesResponse, QrBatchResponse } from '@jq4race/shared';

import { request } from './client.js';

// valet-keychain-qr — super-admin QR batch generation. All routes are
// scoped to super-admin/organizations/:orgId/locations/:locationId/qr-batches.

function basePath(orgId: string, locationId: string): string {
  return `/super-admin/organizations/${encodeURIComponent(orgId)}/locations/${encodeURIComponent(locationId)}/qr-batches`;
}

export async function createQrBatch(
  orgId: string,
  locationId: string,
  input: CreateQrBatchRequest,
): Promise<QrBatchResponse> {
  return request<QrBatchResponse>(basePath(orgId, locationId), {
    method: 'POST',
    body: input,
  });
}

export async function listQrBatches(
  orgId: string,
  locationId: string,
): Promise<ListQrBatchesResponse> {
  return request<ListQrBatchesResponse>(basePath(orgId, locationId), { method: 'GET' });
}

/** Reprint — regenerates the full code list from the stored batch's prefix+range. */
export async function getQrBatch(
  orgId: string,
  locationId: string,
  batchId: string,
): Promise<QrBatchResponse> {
  return request<QrBatchResponse>(`${basePath(orgId, locationId)}/${encodeURIComponent(batchId)}`, {
    method: 'GET',
  });
}
